'use strict';

import { SET_AUTH_DATA } from './index.js';

export function setAuthData(token, refreshToken) {
  return {
    type: SET_AUTH_DATA,
    payload: {
      token,
      refreshToken,
      isAuthed: token && token.length > 0
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/setAuthData.js